// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getBrandTargets } from "@vanmeter/App/Services/FieldEditorServices";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess<string[]> & HasOnError<string> & {},
    {},
    ServiceResult<string[]>
>;

export const DispatchBeginLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "CustomerPerformance/BeginLoadData",
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBrandTargets();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const chain = [DispatchBeginLoadOrders, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const brandTargetsHandler = createHandlerChainRunner(chain, "brandTargetsHandler");
export default brandTargetsHandler;
